import { ArrowCounterClockwise } from "@phosphor-icons/react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import { Button } from "common/components/ui/Button";

import NoResultsImage from "assets/images/empty-placeholders/result-not-found.png";

interface NoResultsPlaceholderProps {
  hasKeywords: boolean;
  hasOtherFilters: boolean;
  clearKeywords: () => void;
  clearOtherFilters: () => void;
}

export default function NoResultsPlaceholder({
  hasKeywords,
  hasOtherFilters,
  clearOtherFilters,
  clearKeywords,
}: NoResultsPlaceholderProps) {
  let emptyPlaceholderSubtitle =
    "There were no results found for your search. Try searching for something else";

  if (hasOtherFilters && !hasKeywords) {
    emptyPlaceholderSubtitle = "No results found for selected filters";
  }

  return (
    <EmptyPlaceholder
      imageSrc={NoResultsImage}
      title="No results found"
      subtitle={emptyPlaceholderSubtitle}
      actionComponent={
        <Button
          leftIcon={<ArrowCounterClockwise />}
          variant="outline-black"
          onClick={() => {
            if (hasOtherFilters) {
              clearOtherFilters();
              return;
            }
            clearKeywords();
          }}
        >
          Clear {hasOtherFilters ? "all filters" : "search"}
        </Button>
      }
    />
  );
}
